import { combineReducers } from "redux";
import { reducer as formReducer } from "redux-form";

import auth from "./auth";
import data from "./data";
import shared from "./shared";

export default combineReducers({
  auth,
  data,
  shared,
  form: formReducer
});
